/**
 * @file   公用的http对象
 * @create Li yiran 2020/11/10
 */
// import { createHttpClient } from '@portal-site/data';
import { message } from 'antd';
import axios from 'axios';
import { history } from '../desktop/routes';
// 全局API路径前缀
const ENV_API = window.ENV_API;
const ENV_API2 = window.ENV_API2;
const ENV_API_HOME = window.ENV_API_HOME;
const QuestionAnswerAPI = window.QuestionAnswerAPI;
// const APPID = process.env.ENV_APPID;
// const TOKEN = process.env.ENV_TOKEN;
// const tenantId = '46326dcd68e04556b08d467be26c4859'; // 知识库标识 天地之中
// const tenantId = '83fd9c857e3c4c828b031846358321c6'; // 应国
const tenantId = '37fbfa32fb844df884b1144014dc60f6'; // 知识库标识 徽派建筑
export const http = axios.create({ baseURL: ENV_API });
export const http1 = axios.create({ baseURL: ENV_API_HOME });
export const http2 = axios.create({ baseURL: ENV_API2 });
export const questionHttp = axios.create({ baseURL: QuestionAnswerAPI });

http.interceptors.request.use((config) => {
  config.headers['tenantId'] = tenantId;

  const token = localStorage.getItem('TOKEN');
  if (token) {
    config.headers['Authorization'] = token;
  }
  return config;
});
http2.interceptors.request.use((config) => {
  config.headers['tenantId'] = tenantId;

  // const token = localStorage.getItem('TOKEN');
  // if (token) {
  //   config.headers['Authorization'] = token;
  // }
  return config;
});
questionHttp.interceptors.request.use((config) => {
  config.headers['tenantId'] = tenantId;
  return config;
});

/**
 * response拦截器
 */
http.interceptors.response.use(
  async (res) => {
    const code = res?.data?.code;
    if (code === 200) {
      // return res?.data?.data || true;
      return res?.data?.data || res?.data;
    } else if (code === 5101 || code === 501 || code === 5202 || code === 5106 || code === 5104) {
      message.error(res?.data?.msg);
    } else if (code === 5105) {
      const result = {
        code,
        msg: res?.data?.msg
      };
      return result;
    } else if (code === 5102) {
      const result = {
        code: 5102,
        msg: res?.data?.msg
      };
      return result;
    } else if (code === 5103 || code === 5104 || code === 604) {
      const result = {
        code,
        msg: res?.data?.msg
      };
      return result;
    } else if (code === 5108) {
      return res.data;
    } else if (!code) {
      return res;
    } else if (res.request?.responseType === 'blob') {
      return res?.data;
    } else if (res?.data?.['@context']) {
      return res?.data;
    }
    // else {
    //   // 要求没有特殊要求的，都要提示。这在后期肯定会扯提示太多的问题！//bingo
    //   message.error(res?.data?.msg);
    //   return res?.data || res;
    // }
  },
  (error) => {
    console.error('响应拦截器', error);
    if (axios.isCancel(error)) {
      console.error('取消接口');
    } else {
      if (error?.response?.status === 401) {
        localStorage.clear();
        // message.error(error?.response?.data?.message);
        const pathname = window.location.pathname;
        if (
          pathname?.includes('PersonalPage') ||
          pathname?.includes('PaymentSucceeded') ||
          pathname?.includes('Order')
        ) {
          history.push('/');
          window.location.reload();
        }
      } else {
        const errorMessage =
          error?.response?.data?.message || error?.response?.data?.error || '服务器异常';
        console.error('响应拦截器', errorMessage);
        // message.error(errorMessage);
      }
    }
  }
);
http1.interceptors.response.use(
  async (res) => {
    const code = res?.data?.code;
    if (code === 200) {
      return res?.data?.data || true;
    } else if (code === 5101 || code === 501 || code === 5105 || code === 5202 || code === 5106 || code === 5104) {
      message.error(res?.data?.msg);
    } else if (code === 5102) {
      const result = {
        code: 5102,
        msg: res?.data?.msg
      };
      return result;
    } else if (code === 5103 || code === 604) {
      const result = {
        code,
        msg: res?.data?.msg
      };
      return result;
    } else if (!code) {
      return res;
    } else if (res.request?.responseType === 'blob') {
      return res?.data;
    } else if (res?.data?.['@context']) {
      return res?.data;
    }
    // else {
    //   // 要求没有特殊要求的，都要提示。这在后期肯定会扯提示太多的问题！//bingo
    //   message.error(res?.data?.msg);
    //   return res?.data || res;
    // }
  },
  (error) => {
    console.error('响应拦截器', error);
    if (axios.isCancel(error)) {
      console.error('取消接口');
    } else {
      if (error?.response?.status === 401) {
        localStorage.clear();
        // message.error(error?.response?.data?.message);
        const pathname = window.location.pathname;
        if (
          pathname?.includes('PersonalPage') ||
          pathname?.includes('PaymentSucceeded') ||
          pathname?.includes('Order')
        ) {
          history.push('/');
          window.location.reload();
        }
      } else {
        const errorMessage =
          error?.response?.data?.message || error?.response?.data?.error || '服务器异常';
        console.error('响应拦截器', errorMessage);
        // message.error(errorMessage);
      }
    }
  }
);
http2.interceptors.response.use(
  async (res) => {
    const code = res?.data?.code;
    if (code === 200) {
      return res?.data?.data || true;
    } else if (code === 5101 || code === 501 || code === 5105 || code === 5202 || code === 5106 || code === 5104) {
      message.error(res?.data?.msg);
    } else if (code === 5102) {
      const result = {
        code: 5102,
        msg: res?.data?.msg
      };
      return result;
    } else if (code === 5103 || code === 604) {
      const result = {
        code,
        msg: res?.data?.msg
      };
      return result;
    } else if (!code) {
      return res;
    } else if (res.request?.responseType === 'blob') {
      return res?.data;
    } else if (res?.data?.['@context']) {
      return res?.data;
    }
    // else {
    //   // 要求没有特殊要求的，都要提示。这在后期肯定会扯提示太多的问题！//bingo
    //   message.error(res?.data?.msg);
    //   return res?.data || res;
    // }
  },
  (error) => {
    console.error('响应拦截器', error);
    if (axios.isCancel(error)) {
      console.error('取消接口');
    } else {
      if (error?.response?.status === 401) {
        localStorage.clear();
        // message.error(error?.response?.data?.message);
        const pathname = window.location.pathname;
        if (
          pathname?.includes('PersonalPage') ||
          pathname?.includes('PaymentSucceeded') ||
          pathname?.includes('Order')
        ) {
          history.push('/');
          window.location.reload();
        }
      } else {
        const errorMessage =
          error?.response?.data?.message || error?.response?.data?.error || '服务器异常';
        console.error('响应拦截器', errorMessage);
        // message.error(errorMessage);
      }
    }
  }
);

questionHttp.interceptors.response.use(
  async (res) => {
    const code = res?.data?.code;
    if (code === 200) {
      return res?.data?.data || true;
    } else if (code === 5101 || code === 501 || code === 5105 || code === 5202 || code === 5106 || code === 5104) {
      message.error(res?.data?.msg);
    } else if (code === 5102) {
      const result = {
        code: 5102,
        msg: res?.data?.msg
      };
      return result;
    } else if (code === 5103 || code === 604) {
      const result = {
        code,
        msg: res?.data?.msg
      };
      return result;
    } else if (!code) {
      return res;
    } else if (res.request?.responseType === 'blob') {
      return res?.data;
    } else if (res?.data?.['@context']) {
      return res?.data;
    }
    // else {
    //   // 要求没有特殊要求的，都要提示。这在后期肯定会扯提示太多的问题！//bingo
    //   message.error(res?.data?.msg);
    //   return res?.data || res;
    // }
  },
  (error) => {
    console.error('响应拦截器', error);
    if (axios.isCancel(error)) {
      console.error('取消接口');
    } else {
      if (error?.response?.status === 401) {
        localStorage.clear();
        // message.error(error?.response?.data?.message);
        const pathname = window.location.pathname;
        if (
          pathname?.includes('PersonalPage') ||
          pathname?.includes('PaymentSucceeded') ||
          pathname?.includes('Order')
        ) {
          history.push('/');
          window.location.reload();
        }
      } else {
        const errorMessage =
          error?.response?.data?.message || error?.response?.data?.error || '服务器异常';
        console.error('响应拦截器', errorMessage);
        // message.error(errorMessage);
      }
    }
  }
);
